module.exports = {
  mock: false, // mock 开关
  mockUrl: 'http://192.168.51.34:9999/InvSvr', // mock地址
  realUrl: 'http://127.0.0.1:8888/InvSvr', // 真实盘地址
  isMainDisk: 'false', // 是否模拟0号盘
  SSOLogin: 'true', // 是否集成单点登录
  NEED_INDEX: 'false', // 是否需要首页
  nokey: false, // 是否无key
  publicPath: '', // 发布路径 eg: 静态服务器上的发布地址,
}



//////////////////
// WEBPACK FOOTER
// ./build/config.js
// module id = c0zf
// module chunks = 0